package com.shadowings.gero.presentation.widget

import androidx.compose.runtime.Composable

@Composable
actual fun rememberAddStrikeWidgetAction(): (() -> Unit)? = null

actual fun notifyStrikeWidgetDataChanged() = Unit
